<template>
    <div class="dangerhub">
        <div class="hubheader">
            <div class="hubitem">
                <img class="img" src="@/assets/newscreen/dangerHubHeader1.png" alt="">
                <div class="info">
                    <div class="label">总入库</div>
                    <div class="value value1"><span class="HF-Duguts">{{ countObj.total_count }}</span> <span
                            class="unit">吨</span></div>
                </div>
            </div>
            <div class="hubitem">
                <img class="img" src="@/assets/newscreen/dangerHubHeader2.png" alt="">
                <div class="info">
                    <div class="label">总出库</div>
                    <div class="value value1"><span class="HF-Duguts">{{ countObj.outbound_count }}</span> <span
                            class="unit">吨</span></div>
                </div>
            </div>
            <div class="hubitem">
                <img class="img" src="@/assets/newscreen/dangerHubHeader3.png" alt="">
                <div class="info">
                    <div class="label">总库存</div>
                    <div class="value value1"><span class="HF-Duguts">{{ countObj.not_outbound_count }}</span> <span
                            class="unit">吨</span></div>
                </div>
            </div>
        </div>
        <div class="chart" ref="chart"></div>
    </div>
</template>

<script>
import { getOption } from './dangerHub.js';
import echarts from 'echarts';

export default {
    data() {
        return {
            myChart: null,
            countObj: {
                not_outbound_count: "-",
                outbound_count: "-",
                total_count: "-"
            },
            listTotal: 0,
            listData: [],
            current: 1,
            timer: null
        }
    },
    mounted() {
        this.myChart = echarts.init(this.$refs.chart);
        window.addEventListener("resize", this.resize);
        this.pageDataInit();
        this.timer = setInterval(() => {
            this.pageDataInit();
        }, 60 * 1000)
    },
    destroyed() {
        window.removeEventListener("resize", this.resize);
        clearInterval(this.timer)
    },
    methods: {
        async pageDataInit() {
            this.getData();
            await this.getChartData();
            this.drawChart();
        },
        getData() {
            this.$api.newscreen.getInventory({}, ["uuid", "company"]).then(res => {
                let data = res.data;
                for (let i = 0; i < data.length; i++) {
                    if (data[i].data === "not_outbound_count") {
                        this.countObj.not_outbound_count = this.countInit(data[i].count);
                    } else if (data[i].data === "outbound_count") {
                        this.countObj.outbound_count = this.countInit(data[i].count);
                    } else if (data[i].data === "total_count") {
                        this.countObj.total_count = this.countInit(data[i].count);
                    }
                }
            })
        },
        getChartData() {
            return this.$api.newscreen.getStatistics({}, ["uuid", "company"]).then(res => {
                let data = res.data;
                this.listTotal = data.length;
                this.listData = data;
                this.$emit("loadok", {
                    total: this.listTotal,
                    page: 10
                })
            })
        },
        countInit(val) {
            return this.formatNumber(val);
        },
        formatNumber(num) {
            let str = num + "";
            let list = str.split(".");
            if (list[1]) {
                // 有小数
                list[1] = list[1].substring(0, 4 - list[0].length);
            }
            //console.log(list)
            return parseFloat(list.join('.'));
        },
        drawChart() {
            let option = getOption(this.listData.slice((this.current - 1) * 10, this.current * 10));
            console.log('drawChart', option)
            this.myChart.setOption(option);
        },
        goPage(current) {
            this.current = current;
            let option = getOption(this.listData.slice((this.current - 1) * 10, this.current * 10));
            this.myChart.setOption(option);
        },
        resize() {
            this.myChart.resize();
        }
    }
}
</script>

<style lang="scss" scoped>
.dangerhub {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;

    .hubheader {
        display: flex;
        padding: 1rem;
        justify-content: space-between;
        white-space: nowrap;

        .hubitem {
            display: flex;
            align-items: center;
            padding: 0 1rem;
            width: 30%;
            overflow: hidden;
            max-height: 4rem;
            position: relative;
            .img{
                height: 100%;
            }

            .info {
                position: absolute;
                right: 0;
                padding-right: 1rem;
                display: flex;
                flex-direction: column;


                .label {
                    color: #5A7EA9; //2333;
                    font-size: 0.875rem;
                }

                .value {
                    flex: 1;
                    font-size: 1.5rem;
                    font-weight: 900;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }
            }
        }

        .hubitem:nth-child(2) {}

        .value1 {
            color: #00EDF3;
            letter-spacing: 0;
            text-shadow: 0 0 1rem #44D7B6;
        }

        .value2 {
            color: #EE9F3B;
            letter-spacing: 0;
            text-shadow: 0 0 1rem #EE9F3B;
        }

        .value3 {
            color: #FFFFFF;
            letter-spacing: 0;
            text-shadow: 0 0 1rem #44D7B6;
        }

        .unit {
            font-size: 0.875rem;
            color: #fff;
            margin-left: 0.5rem;
        }
    }

    .chart {
        flex: 1;
    }
}

@media screen and (max-width: 1840px) {
    .dangerhub .hubheader .hubitem .value {
        font-size: 1.65rem !important;
    }
}

@media screen and (max-width: 1740px) {
    .dangerhub .hubheader .hubitem .value {
        font-size: 1.5rem !important;
    }
}
</style>